var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMyclassOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 22,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ic-myclass-on_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#479DA6",
  d: "M2.84 0h18.338c1.01 0 1.831.82 1.831 1.831v12.857c0 1.01-.82 1.841-1.84 1.841H2.83c-1.01 0-1.831-.82-1.831-1.831V1.841C1 .821 1.82 0 2.84 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#66BBBF",
  d: "M16.807 15.418c0 .62-.4 1.12-.9 1.12H8.103c-.5 0-.9-.5-.9-1.12s-.4-1.121-.9-1.121H1c-.55 0-1 .56-1 1.24v3.222C0 19.45.45 20 1 20h22c.55 0 1-.56 1-1.24v-3.222c0-.69-.45-1.241-1-1.241h-5.303c-.5 0-.9.5-.9 1.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6F0F1",
  d: "M17.656 6.534h-7.513c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h7.513c.5 0 .9.4.9.9s-.4.9-.9.9M17.656 10.636h-7.513c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h7.513c.5 0 .9.4.9.9s-.4.9-.9.9M7.251 5.604a.9.9 0 1 0-1.8 0v4.142a.9.9 0 1 0 1.8 0z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ic-myclass-on_svg__a",
  width: 32,
  height: 28,
  x: -4,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2195_82610"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2195_82610",
  result: "shape"
})))));
export default SvgIcMyclassOn;